export default {
      id: "common__slider-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__slider",
      toString: function () {
        return this.url;
      }
    }